import { fmhAPI, REFERENCE_API_URL } from 'api/APIBase';

export async function updateFax({ prescriberNpi, supplierNpi, faxNumber, faxType }) {
    if (faxType === 'prescriber') {
        const url = `${REFERENCE_API_URL}/prescribers/${prescriberNpi}/update-fax`;
        return fmhAPI.base.url(url).put({
            fax_number: faxNumber,
        });
    }
    if (faxType === 'supplier') {
        const url = `${REFERENCE_API_URL}/suppliers/${supplierNpi}/update-fax`;
        return fmhAPI.base.url(url).put({
            fax_number: faxNumber,
        });
    }
    return ' ';
}
